/* Section avis — rendu depuis gl-avis.json, pagination par paquets */
(function () {
  var PAQUET = 12;

  function etoiles(n) {
    var pleines = Math.round(n || 5), s = '';
    for (var i = 1; i <= 5; i++) s += i <= pleines ? '★' : '<span>★</span>';
    return s;
  }

  function echapper(t) {
    var d = document.createElement('div');
    d.textContent = t == null ? '' : String(t);
    return d.innerHTML;
  }

  function carte(a) {
    var h = '<article class="gl-avis__carte">';
    if (a.photo) {
      h += '<div class="gl-avis__photo"><img src="' + echapper(a.photo) + '" alt="" loading="lazy" width="400" height="400">';
      if (a.photos > 1) {
        h += '<span class="gl-avis__compteur">' + a.photos +
             ' <svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true">' +
             '<rect x="3" y="3" width="18" height="18" rx="2"/><circle cx="8.5" cy="8.5" r="1.5"/><path d="m21 15-5-5L5 21"/></svg></span>';
      }
      h += '</div>';
    }
    h += '<div class="gl-avis__corps">';
    h += '<p class="gl-avis__nom">' + echapper(a.nom) + '</p>';
    h += '<div class="gl-avis__etoiles" role="img" aria-label="' + (a.note || 5) + ' sur 5">' + etoiles(a.note) + '</div>';
    if (a.texte) h += '<p class="gl-avis__texte">' + echapper(a.texte) + '</p>';
    return h + '</div></article>';
  }

  function monter(racine, avis, meta) {
    var grille = racine.querySelector('.gl-avis__grille');
    var pied = racine.querySelector('.gl-avis__plus');
    var tete = racine.querySelector('.gl-avis__tete');
    var affiches = 0;

    if (!avis.length) {
      grille.innerHTML = '<p class="gl-avis__vide">Aucun avis pour le moment. Soyez la première à donner le vôtre.</p>';
      if (pied) pied.remove();
      return;
    }

    var somme = avis.reduce(function (t, a) { return t + (a.note || 5); }, 0);
    var note = (meta && meta.note) || somme / avis.length;
    var total = (meta && meta.total) || avis.length;
    tete.querySelector('.gl-avis__etoiles').innerHTML = etoiles(note);
    tete.querySelector('.gl-avis__chiffre').textContent = note.toFixed(1).replace('.', ',');
    tete.querySelector('.gl-avis__total').textContent = '(' + String(total).replace(/\B(?=(\d{3})+(?!\d))/g, '\u202f') + ' avis)';

    function suite() {
      var lot = avis.slice(affiches, affiches + PAQUET);
      grille.insertAdjacentHTML('beforeend', lot.map(carte).join(''));
      affiches += lot.length;
      if (pied) pied.hidden = affiches >= avis.length;
    }
    suite();
    if (pied) pied.querySelector('button').addEventListener('click', suite);
  }

  function demarrer(racine) {
    if (racine.dataset.monte) return;
    racine.dataset.monte = '1';
    fetch(racine.dataset.source, { headers: { accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : []; })
      .then(function (d) {
        var liste = Array.isArray(d) ? d : (d.avis || []);
        monter(racine, liste, Array.isArray(d) ? null : d.meta);
      })
      .catch(function () { monter(racine, []); });
  }

  function init() {
    document.querySelectorAll('.gl-avis').forEach(function (racine) {
      if (!('IntersectionObserver' in window)) return demarrer(racine);
      var o = new IntersectionObserver(function (e) {
        if (e[0].isIntersecting) { o.disconnect(); demarrer(racine); }
      }, { rootMargin: '600px' });
      o.observe(racine);
      // filet : si l'observateur ne se declenche jamais, on monte quand meme
      setTimeout(function () { demarrer(racine); }, 4000);
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
